import PageTitle from "comps/PageTitle";
import React from "react";
import "../styles/navbar-tooltips.css";
import { WHATSAPP_BOOKING_URL } from "../utils/contactDetails";


export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <nav
      className={
        (props.transparent
          ? "top-0 absolute z-50 w-full"
          : "relative shadow-lg bg-white shadow-lg") +
        " flex flex-wrap items-center justify-between px-2 py-3 " +
        (props.className ? ` ${props.className}` : "")
      }
    >
      <div className="container relative px-4 mx-auto flex flex-wrap items-center justify-between">
        <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
          <PageTitle/>
          <button
            className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
            type="button"
            onClick={() => setNavbarOpen(!navbarOpen)}
            aria-expanded={navbarOpen}
            aria-controls="example-navbar-warning"
            aria-label={navbarOpen ? "Close navigation menu" : "Open navigation menu"}
          >
            <i
              className={
                (props.transparent ? "text-red-200" : "text-gray-800") +
                " fas fa-bars"
              }
            ></i>
          </button>
        </div>
        <div
          className={
            "nav-menu-panel lg:flex flex-grow items-center lg:shadow-none" +
            (navbarOpen ? " nav-menu-panel--open block" : " hidden")
          }
          id="example-navbar-warning"
        >
          <ul className="nav-icon-list flex flex-col lg:flex-row list-none lg:ml-auto">
            <li className="flex items-center">
              <a
                className={
                  "nav-icon-tooltip nav-icon-button flex items-center text-xs uppercase font-bold"
                }
                href="/rate-chart"
                aria-label="Rate Chart"
                data-tooltip="Rate Chart"
              >
                <i className="text-orange-500 fas fa-tags text-lg leading-lg" />
                <span className="nav-icon-label lg:hidden">Rate Chart</span>
              </a>
            </li>

            <li className="flex items-center">
              <a
                className={
                  "nav-icon-tooltip nav-icon-button flex items-center text-xs uppercase font-bold"
                }
                href="https://www.facebook.com/profile.php?id=100090420534325&mibextid=ZbWKwL"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                data-tooltip="Facebook"
              >
                <i
                  className={
                    "text-blue-500 fab fa-facebook text-lg leading-lg "
                  }
                />
                <span className="nav-icon-label lg:hidden">Facebook</span>
              </a>
            </li>

            <li className="flex items-center">
              <a
                className={
                  "nav-icon-tooltip nav-icon-button flex items-center text-xs uppercase font-bold"
                }
                href="https://instagram.com/arpitaamanna72?igshid=NmQ2ZmYxZjA="
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-tooltip="Instagram"
              >
                <i
                  className={
                    "text-orange-500 fab fa-instagram text-lg leading-lg "
                  }
                />
                <span className="nav-icon-label lg:hidden">Instagram</span>
              </a>
            </li>

            <li className="flex items-center">
              <a
                className={
                  "nav-icon-tooltip nav-icon-button flex items-center text-xs uppercase font-bold"
                }
                href="/profile"
                aria-label="My Profile"
                data-tooltip="My Profile"
              >
                {/* <span style={{fontWeight:700, fontSize:12, marginLeft: 8}}>About</span> */}
               {/* {props.transparent ?  */}
               <i className="text-orange-500 fa-solid fa-user text-lg leading-lg"/>

              <span className="nav-icon-label lg:hidden">My Profile</span>
                
              </a>
            </li>

            <li className="flex items-center">
                 <a
                className={
                  "nav-icon-tooltip nav-icon-button flex items-center text-xs uppercase font-bold"
                }
                href={WHATSAPP_BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Book an appointment on WhatsApp"
                data-tooltip="Book on WhatsApp"
              >
                <i className="text-orange-500 fab fa-whatsapp"></i>
                
              {/* <i className="text-orange-500 fas fa-solid fa-circle-phone"></i> */}
              <span className="nav-icon-label lg:hidden">Book an appointment</span>
              </a>
            </li>

          </ul>
        </div>
      </div>
      <div>
    </div>
    </nav>
  );
}
